var path = 'widget/lib/alarm-status-filter-panel.tpl.html';
var html = " <md-content style=height:100% flex layout=column class=md-padding> <label class=tb-title translate>alarm.alarm-status-filter</label> <md-radio-group ng-model=vm.subscription.alarmSearchStatus class=md-primary> <md-radio-button ng-value=searchStatus aria-label=\"{{ ('alarm.search-status.' + searchStatus) | translate }}\" class=\"md-primary md-align-top-left md-radio-interactive\" ng-repeat=\"searchStatus in vm.types.alarmSearchStatus\"> {{ ('alarm.search-status.' + searchStatus) | translate }} </md-radio-button> </md-radio-group> </md-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/widget/lib/alarm-status-filter-panel.tpl.html
// module id = 1530
// module chunks = 1